import { FormattedMessage } from "react-intl";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import LabelLang from "component/LabelLang/label-lang";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";

function PortalsList({ importantPortals }) {
  if (!importantPortals.length) {
    return <DataNotFound />;
  }

  return importantPortals.map(
    ({ title, link, importantPortalTranslations }, i) => (
      <li key={i}>
        <a id={title} href={link} style={{ color: "#000000" }}>
          <h5 style={{ padding: "14px", fontWeight: "400" }}>
            <LabelLang
              id="title"
              defaultValue={title}
              translations={importantPortalTranslations}
            />
          </h5>
        </a>
        <center>
          <hr
            style={{
              borderWidth: "2px",
              color: "#000000",
              width: "95%",
              opacity: "20%",
            }}
          />
        </center>
      </li>
    ),
  );
}

export default function ImportantPortalsSection({ importantPortals }) {
  return (
    <div className="recommended-news-section">
      <div className="most-read">
        <ul>
          <li>
            <div className="row">
              <div className="col-12 col-lg-9">
                <h4
                  className="header-title pe-3"
                  style={{ fontSize: "8px", fontWeight: "bold" }}
                >
                  <br />
                </h4>
                <h4
                  className="header-title pe-3"
                  style={{ fontSize: "20px", fontWeight: "bold" }}
                >
                  <FormattedMessage id="form-our-page-on" />{" "}
                  <FormattedMessage id="facebook" />
                </h4>
              </div>
              <div className="col-12 col-lg-3">
                <img
                  width={60}
                  height={60}
                  src={`${process.env.PUBLIC_URL}/image/facebook.png`}
                  alt="facebook-icon"
                  loading="lazy"
                />
              </div>
            </div>
          </li>
          <br />
          <center>
            <iframe
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCAPMASEG&tabs=timeline&width=350&height=499&small_header=false&adapt_container_width=true&hide_cover=true&show_facepile=true&appId"
              width={350}
              height={499}
              style={{ border: "none", overflow: "hidden" }}
              scrolling="no"
              frameBorder={0}
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              title="facebook-page"
            />
          </center>
        </ul>
      </div>

      <div className="most-read">
        <ul>
          <li>
            <div className="row">
              <div className="col-12 col-lg-9">
                <h4
                  className="header-title pe-3"
                  style={{ fontSize: "8px", fontWeight: "bold" }}
                >
                  <br />
                </h4>
                <h4
                  className="header-title pe-3"
                  style={{ fontSize: "20px", fontWeight: "bold" }}
                >
                  <FormattedMessage id="form-our-page-on" />{" "}
                  <FormattedMessage id="X" />
                </h4>
              </div>
              <div className="col-12 col-lg-2">
                <img
                  width={75}
                  height={75}
                  src={`${process.env.PUBLIC_URL}/icons/twitter-icon.png`}
                  alt="twitter-icon"
                  loading="lazy"
                />
              </div>
            </div>
          </li>
          <br />
          <center>
            <TwitterTimelineEmbed
              sourceType="profile"
              screenName="capmas_eg"
              options={{
                tweetLimit: "10",
                width: "85%",
                height: "500%",
              }}
              noHeader="true"
              noBorders="true"
              noFooter="true"
            />
            <div className="text-center fw-semibold">
              <a
                href="https://x.com/capmas_eg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage id="follow-us-on" />{" "}
                <FormattedMessage id="X" />
              </a>
            </div>
          </center>
        </ul>
      </div>

      <div className="most-read">
        <div className="row">
          <div className="col-12 col-lg-12">
            <h4
              className="header-title pe-3"
              style={{ fontSize: "8px", fontWeight: "bold" }}
            >
              <br />
            </h4>
            <h4
              className="header-title pe-3"
              style={{ fontSize: "20px", fontWeight: "bold" }}
            >
              <FormattedMessage id="important-links" />
            </h4>
            <ul className="recommended-news-section whats-new">
              <PortalsList importantPortals={importantPortals} />
            </ul>
          </div>
        </div>
        <br />
      </div>
    </div>
  );
}
